import React, { Component, ReactNode } from 'react';
import { connect } from 'react-redux';
import { Button, Form, Input } from 'antd';

import { HubSpotExclusionField } from '../hubspotExclusionField';
import { isPureProfileClient } from '../../../utils/clients';
import { IUserSingleSignOnRequest, userSingleSignOn, userLogout } from '../../../slices/auth/login.thunks';
import { PrimaryButton } from '../../common/primaryButton';
import { signInWithCustomProvider } from '../../../services/cognito';
import { SSO_FIRST_IDENTITY_PROVIDER } from '../../../config';
import { FormInstance } from 'antd/lib/form';
import { getQueryParam } from '../../../utils/queryParameters';

import styles from './login.module.scss';

interface SingleSignOnFormProps {
  onCancel: () => void;
}

interface DispatchProps {
  userSingleSignOn: (request: IUserSingleSignOnRequest) => void;
  userLogout: () => void;
}

type Props = SingleSignOnFormProps & DispatchProps;

class SingleSignOnFormBase extends Component<Props> {
  private readonly formRef: React.RefObject<FormInstance>;

  public constructor(props: Props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.formRef = React.createRef<FormInstance>();
  }

  async componentDidMount() {
    const shouldInitiateSignIn = getQueryParam('initiate-signin');
    if(typeof shouldInitiateSignIn === 'string' && isPureProfileClient()) {
      await this.props.userLogout();
      signInWithCustomProvider(SSO_FIRST_IDENTITY_PROVIDER);
      return;
    }
  }

  private async handleSubmit(values: IUserSingleSignOnRequest) {
    if(isPureProfileClient()) {
      await this.props.userLogout();
      signInWithCustomProvider(SSO_FIRST_IDENTITY_PROVIDER);
      return;
    }
    const { userSingleSignOn } = this.props;
    userSingleSignOn(values);
  }

  public render(): ReactNode {
    const { onCancel } = this.props;
    return (
      <Form className={styles.form} onFinish={this.handleSubmit}>
        {
          isPureProfileClient()
            ? null
            : (
              <Form.Item name="email" rules={[{ type: 'email' }, { required: true }]}>
                <Input placeholder="Email" className={styles.email} bordered={false} />
              </Form.Item>
            )
        }
        <HubSpotExclusionField />
        <PrimaryButton htmlType="submit" type="primary">Sign In</PrimaryButton>
        <div className={styles.linkButton}>
          <Button
            type="link"
            onClick={onCancel}
          >
            Log in with a different method
          </Button>
        </div>
      </Form>
    );
  }
}

const mapDispatchToProps = { userSingleSignOn, userLogout };

export const SingleSignOnForm = connect(null, mapDispatchToProps)(SingleSignOnFormBase);
